export const knowUsServices = [
    {
        title: "Business Software Solutions",
        description: "Deploy CRM, operations, and workflow platforms built for day-to-day business execution.",
    },
    {
        title: "WhatsApp Business Solutions",
        description: "Enable customer communication, campaigns, and support through WhatsApp-powered systems.",
    },
    {
        title: "Web Development",
        description: "Create modern, responsive websites that strengthen brand presence and drive conversions.",
    },
    {
        title: "Mobile App Development",
        description: "Build high-performance mobile applications for Android and iOS business use cases.",
    },
    {
        title: "Digital Marketing",
        description: "Grow visibility, leads, and engagement with data-driven marketing strategies.",
    },
    {
        title: "Business Automation",
        description: "Automate repetitive processes across sales, operations, and customer engagement.",
    },
];

export const knowUsWhyChoose = [
    {
        title: "Custom Solutions",
        description: "Every engagement is tailored to your workflows, teams, and growth priorities.",
    },
    {
        title: "Scalable Technology",
        description: "Solutions are designed to scale as your operations, users, and data grow.",
    },
    {
        title: "Dedicated Support",
        description: "Receive responsive guidance, implementation help, and ongoing partnership support.",
    },
    {
        title: "Growth-Focused Approach",
        description: "Technology decisions are aligned with measurable business outcomes and expansion goals.",
    },
];

export const knowUsProcess = [
    {
        title: "Discover",
        description: "Understand your business goals, challenges, and operational priorities.",
    },
    {
        title: "Plan",
        description: "Define the right roadmap, scope, and technology strategy for execution.",
    },
    {
        title: "Build",
        description: "Develop software, automation, and digital solutions tailored to your needs.",
    },
    {
        title: "Launch",
        description: "Deploy, integrate, and validate solutions with your team and stakeholders.",
    },
    {
        title: "Grow",
        description: "Optimize performance, scale operations, and support long-term business growth.",
    },
];

